/**
 * 플랫폼 하단 사업자·연락처 정보
 * (LuckytemStudioClassLab / 에듀코디 CompanyInfoSection 과 동일 운영 주체)
 */
export const PLATFORM_COMPANY = {
  brandName: '클래스 플래너',
  operatorLine: '제이앤조이 대표자 : 정영은',
  mailOrderLicense: '통신판매업신고번호 : 2024-화성동탄-0316호',
  businessNumber: '사업자등록번호 : 702-04-02761',
  address: '주소 : 경기도 화성시 동탄대로시범길 20. 1415동 2701호',
  phone: '연락처 : 010-7442-0199',
  supportEmailLabel: '결제 및 상담',
  supportEmail: 'edukodi.info@gmail.com',
} as const;
